import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Admissionleft from './Admissoinleft';
import { Container,Row, Col } from 'react-bootstrap';



function Btech_AdmissionELe() {
    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left mb-4'>
                        <Admissionleft activeIndex={5} />
                    </Col>

                    <Col md={8} className='c-left me-8'>
                        <div className="c-heading">
                            <h3>Bachelor of Technology </h3> <br/>
                        </div>
                        
                        <div className="border border-dark">
                            <div className="p-3">
                                <div id="about">
                                   
                                    <p className="caboutus">IIT Tirupati offers B.Tech. degree in Chemical Engineering, Civil Engineering, Computer Science and Engineering, Electrical Engineering, Mechanical Engineering and Physics. The admissions are made through JEE (Advanced). For more details visit <b className='c-link'>https://jeeadv.ac.in/. </b> <br /> <br/>

                                        <span>The applicable tuition and other fee / deposits for B.Tech students is available at the following <Link to="/fee-structure" className='c-link'>link</Link>.
                                    </span>
                                    </p>

                                   
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>

        </section>
    );
}

export default Btech_AdmissionELe;
